export default __webpack_public_path__ + "assets/aa_measure.jpg";